import type { AppConfig } from '#/config/types/AppConfig';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

type Args = {
  sort: SearchSortType;
  appConfig: AppConfig;
};

export function searchAlgoliaIndex({ sort, appConfig }: Args) {
  switch (sort) {
    case 'relevance':
      return appConfig.algolia.siteIndexName;
    case 'newest':
      return appConfig.algolia.sitePublishedDescIndexName;
  }
}
